<template>
  <div id="footer">
    <div class="footer-panel">
      <div class="footer-follow-us flex-start" style="display: none">
        <span class="footer-follow-us-text">关注我们</span>
        <img class="footer-follow-us-icon" src="@/images/com/wechat.png" alt />
        <img class="footer-follow-us-icon" src="@/images/com/weibo.png" alt />
        <img class="footer-follow-us-icon" src="@/images/com/in.png" alt />
      </div>

      <div class="footer-about-us flex-between" @click="goAboutUS">
        <span>关于我们</span>
        <img
          class="footer-right-arrow"
          src="@/images/com/footer_right_arrow.png"
          alt
        />
      </div>
      <div class="footer-contact-us flex-between" @click="goContactUs">
        <span>联系我们</span>
        <img
          class="footer-right-arrow"
          src="@/images/com/footer_right_arrow.png"
          alt
        />
      </div>
      <div class="relevance-title">友情链接</div>
      <div class="relevance">
        <div class="flex-start">
          <a href="https://www.youxituoluo.com" target="_blank">游戏陀螺</a>
          <span>丨</span>
          <a href="https://www.tuoluohuodong.com/" target="_blank">陀螺活动</a>
          <span>丨</span>
          <a href="http://www.tuoluocard.com" target="_blank">陀螺名片</a>
          <span>丨</span>
          <a href="https://www.tuoluocaijing.cn" target="_blank">陀螺财经</a>
          <span>丨</span>
          <a href="https://fbec.info/" target="_blank">FBEC2020</a>
        </div>
        <div class="flex-start">
          <a href="https://www.vrtuoluo.cn" target="_blank">VR陀螺</a>
          <span>丨</span>
          <a href="http://www.yunyingrl.com/" target="_blank">云鹦日历</a>
          <span>丨</span>
          <a href="http://www.bixiaocrm.com/" target="_blank">必效CRM</a>
          <span>丨</span>
          <a href="https://www.retouchspace.com/" target="_blank">锐量</a>
          <span>丨</span>
          <a href="http://www.civicivitech.com/" target="_blank">CiViCiVi</a>
        </div>
      </div>
      <div class="footer-case-number flex-start">
        <span>粤ICP备13090461号</span>
        <span>粤公网安备 44030502000464号</span>
      </div>
      <div class="footer-all-rights-reserved">
        <div>Copyright ©2020 tuoluo.cn All Rigths Reserved.</div>
        <div>深圳市游迷天下科技有限公司 版权所有</div>
      </div>
    </div>
    <div class="back-to-top-panel" @click="backtop">返回顶部</div>
  </div>
</template>

<script>
export default {
  name: "comFooter",
  data() {
    return {};
  },
  mounted() {
    window.addEventListener("scroll", this.showbtn, true);
  },
  methods: {
    goAboutUS() {
      this.$router.push({
        path: "aboutUs",
      });
    },
    goContactUs() {
      this.$router.push({
        path: "contactUs",
      });
    },
    // 显示回到顶部按钮
    showbtn() {
      let that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      that.scrollTop = scrollTop;
    },
    /**
     * 回到顶部功能实现过程：
     * 1. 获取页面当前距离顶部的滚动距离（虽然IE不常用了，但还是需要考虑一下兼容性的）
     * 2. 计算出每次向上移动的距离，用负的滚动距离除以5，因为滚动的距离是一个正数，想向上移动就是做一个减法
     * 3. 用当前距离加上计算出的距离，然后赋值给当前距离，就可以达到向上移动的效果
     * 4. 最后记得在移动到顶部时，清除定时器
     */
    backtop() {
      var timer = setInterval(function () {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed;
        this.isTop = true;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30);
    },
  },
};
</script>

<style>
.footer-panel {
  /*    width: 100%;
    height:6.14rem; */
  background: rgba(242, 243, 245, 1);
  padding: 0.6rem 0.38rem 1.1rem 0.48rem;
}
.footer-right-arrow {
  width: 0.11rem;
  height: 0.18rem;
}
.relevance-title {
  margin-bottom: 0.28rem;
}
.relevance {
  line-height: 0.4rem;
  margin-bottom: 0.6rem;
}
.relevance a {
  font-size: 0.14rem;
  font-weight: 400;
  color: rgba(53, 51, 64, 0.4);
  cursor: pointer;
}
.relevance span {
  padding: 0 0.05rem;
  font-size: 0.14rem;
  color: rgba(53, 51, 64, 0.4);
}
.footer-follow-us-icon {
  width: 0.4rem;
  height: 0.4rem;
  margin-left: 0.38rem;
}
.footer-follow-us-text,
.footer-about-us,
.footer-contact-us,
.relevance-title {
  font-size: 0.3rem;
  font-weight: 400;
  color: rgba(53, 51, 64, 0.8);
}
.footer-follow-us,
.footer-about-us,
.footer-contact-us {
  margin-bottom: 0.3rem;
}
.footer-case-number span,
.footer-all-rights-reserved {
  font-size: 0.22rem;
  font-weight: 400;
  color: rgba(53, 51, 64, 0.8);
}
.footer-case-number {
  margin: 0.8rem 0 0.36rem 0;
}
.footer-all-rights-reserved {
  line-height: 0.36rem;
}
.back-to-top-panel {
  width: 100%;
  height: 0.8rem;
  line-height: 0.8rem;
  text-align: center;
  background: rgba(53, 51, 64, 0.2);
  font-size: 0.28rem;
  font-weight: 400;
  color: rgba(53, 51, 64, 0.8);
}
</style>



// WEBPACK FOOTER //
// src/components/nav/comFooter.vue